import { create } from 'zustand';

export const useConfirmDialogStore = create((set, get) => ({
  isOpen: false,
  config: {},
  resolveCallback: null,

  // Show the confirm dialog and return a promise that resolves to true/false
  showConfirm: (config) => {
    return new Promise((resolve) => {
      set({
        isOpen: true,
        config: {
          title: config.title || 'Confirm Action',
          message: config.message || 'Are you sure you want to continue?',
          confirmLabel: config.confirmLabel || 'Continue',
          cancelLabel: config.cancelLabel || 'Cancel',
          variant: config.variant || 'warning', // 'warning', 'danger', 'info'
          mode: 'confirm',
        },
        resolveCallback: resolve,
      });
    });
  },

  // Show a simple alert dialog with just an OK button
  showAlert: (config) => {
    return new Promise((resolve) => {
      set({
        isOpen: true,
        config: {
          title: config.title || 'Alert',
          message: config.message || '',
          confirmLabel: config.confirmLabel || 'OK',
          variant: config.variant || 'warning',
          mode: 'alert',
        },
        resolveCallback: resolve,
      });
    });
  },

  // User confirmed the action
  confirm: () => {
    const { resolveCallback } = get();
    if (resolveCallback) {
      resolveCallback(true);
    }
    set({ isOpen: false, config: {}, resolveCallback: null });
  },

  // User cancelled the action
  cancel: () => {
    const { resolveCallback } = get();
    if (resolveCallback) {
      resolveCallback(false);
    }
    set({ isOpen: false, config: {}, resolveCallback: null });
  },
}));
